/*
 * Ryan O'Dowd
 * 2025-11-15
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import CPassage from '@classes/Passage';
import hooks from '@hooks';

export default function usePassageApiNotationToParts(passageApiNotation) {
  const translations = hooks.useTypedSelector((state) => state.translations);

  if (!passageApiNotation) {
    return null;
  }

  try {
    const [bookApiId, chapterNumber, verseRange, translationApiId] = passageApiNotation.split('.');

    const translationId = (Object.values(translations).find((t: any) => t.abbreviation === translationApiId) as any)?.id;

    const verseNums = verseRange.split('-').map(Number);
    const [startVerseNumber, endVerseNumber] = [verseNums[0], verseNums[1] ?? verseNums[0]];

    if (startVerseNumber > endVerseNumber) {
      return null;
    }

    return {
      translationId,
      bookId: CPassage.getBookFromApiId(bookApiId).id,
      chapterNumber: +chapterNumber,
      startVerseNumber,
      endVerseNumber,
    };
  } catch (__error) {
    return null;
  }
}
